import { Button } from '@/design-system/button/button';
import { InvoiceEvidenceView } from '@/types/entity-types';
import { getSwrFetcherWithDynamicUrl } from '@/utils/get-swr-fetcher-with-dynamic-url';
import { ReactNode, useState } from 'react';
import useSWRMutation from 'swr/mutation';
import { DOCUMENT_URL } from '../../invoice-pay-page-inner-wrapper';
import { getBeneficiaryCardConfig } from '../../utils/get-beneficiary-card-config';
import { InvoiceDrawer } from './invoice-drawer';

type InvoiceDrawerTriggerProps = {
  rowEvidence: InvoiceEvidenceView;
  children: ReactNode;
};

export const InvoiceDrawerTrigger = ({ rowEvidence, children }: InvoiceDrawerTriggerProps) => {
  const [isInvoiceDrawerOpen, setIsInvoiceDrawerOpen] = useState(false);

  const {
    trigger: triggerDocumentUrl,
    isMutating: isTriggeringDocumentUrl,
    data: documentUrl,
  } = useSWRMutation<{ url: string }, Error, string, { urlSuffix: string }>(DOCUMENT_URL, getSwrFetcherWithDynamicUrl);

  return (
    <>
      <Button
        variant="default"
        isLoading={isTriggeringDocumentUrl}
        onClick={async () => {
          await triggerDocumentUrl({ urlSuffix: `/${rowEvidence.documentId}/signed-url` });

          setIsInvoiceDrawerOpen(true);
        }}
      >
        {children}
      </Button>

      {documentUrl && (
        <InvoiceDrawer
          isOpen={!!isInvoiceDrawerOpen}
          onClose={() => setIsInvoiceDrawerOpen(false)}
          invoiceDrawerContentConfig={{
            invoiceVendor:
              rowEvidence?.suggestedBeneficiary?.name ?? rowEvidence?.vendorInformation?.vendorCompanyName ?? 'Unknown',
            pdfConfig: {
              url: documentUrl.url,
            },
            navigationConfig: {
              isVisible: false,
            },
            contentBodyConfig: {
              variant: 'PAID_NO_TRANSACTION',
              beneficiaryCardConfig: getBeneficiaryCardConfig(rowEvidence),

              summaryConfig:
                rowEvidence.summary || rowEvidence.emailInformation?.fromEmail
                  ? {
                      isVisible: true,
                      summary: rowEvidence.summary,
                      fromEmail: rowEvidence.emailInformation?.fromEmail,
                    }
                  : {
                      isVisible: false,
                    },
            },
            // TODO: we should amend the drawer api not to require this callback when triggered from the paid tab
            onMarkNotInvoice: () => {},
          }}
        />
      )}
    </>
  );
};
